/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { CheckPaymentRequired200ResponseData } from './CheckPaymentRequired200ResponseData'
import {
  CheckPaymentRequired200ResponseDataFromJSON,
  CheckPaymentRequired200ResponseDataFromJSONTyped,
  CheckPaymentRequired200ResponseDataToJSON,
} from './CheckPaymentRequired200ResponseData'

/**
 *
 * @export
 * @interface CheckPaymentRequired200Response
 */
export interface CheckPaymentRequired200Response {
  /**
   *
   * @type {boolean}
   * @memberof CheckPaymentRequired200Response
   */
  status: boolean
  /**
   *
   * @type {CheckPaymentRequired200ResponseData}
   * @memberof CheckPaymentRequired200Response
   */
  data: CheckPaymentRequired200ResponseData
}

/**
 * Check if a given object implements the CheckPaymentRequired200Response interface.
 */
export function instanceOfCheckPaymentRequired200Response(
  value: object
): value is CheckPaymentRequired200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function CheckPaymentRequired200ResponseFromJSON(
  json: any
): CheckPaymentRequired200Response {
  return CheckPaymentRequired200ResponseFromJSONTyped(json, false)
}

export function CheckPaymentRequired200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CheckPaymentRequired200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: CheckPaymentRequired200ResponseDataFromJSON(json['data']),
  }
}

export function CheckPaymentRequired200ResponseToJSON(
  value?: CheckPaymentRequired200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: CheckPaymentRequired200ResponseDataToJSON(value['data']),
  }
}
